import { useFormWithStateContext } from 'contexts/FormWithStateContext';
import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CurrencyCode } from 'further-types/lp/vehicle';
import {
  CapitalActionFormState,
  UpdateCapitalActionFormValues,
} from '../../../hooks/useCapitalActionForm';
import AdvanceSubscriptionAllocations from './AdvanceSubscriptionAllocations';
import { Divider } from 'further-ui/components/Layout';

type Props = {
  index: number;
  vehicleId: string;
  entryType: CapitalActionEntryType;
  baseCurrency: CurrencyCode;
};

const AdvanceSubscriptionPaymentDetails: React.FC<Props> = ({
  index,
  vehicleId,
  baseCurrency,
}) => {
  const {
    formMethods: { watch, setValue },
  } = useFormWithStateContext<
    UpdateCapitalActionFormValues,
    CapitalActionFormState
  >();

  const capitalBreakdown = watch(`entries.${index}.capitalBreakdown`);

  const handleAllocationsChange = (
    allocations: Array<{
      commitmentId: string;
      fundsCalled?: {
        fromCommitmentLcy: number;
        fromRecallableDistributionLcy: number;
      };
    }>,
  ) => {
    const totalAmount = allocations.reduce(
      (sum, allocation) =>
        sum +
        (allocation.fundsCalled?.fromCommitmentLcy ?? 0) +
        (allocation.fundsCalled?.fromRecallableDistributionLcy ?? 0),
      0,
    );

    setValue(`entries.${index}.totalAmountLcy`, totalAmount);
    setValue(
      `entries.${index}.capitalBreakdown`,
      allocations.map((allocation) => ({
        commitmentId: allocation.commitmentId,
        fundsCalled: {
          fromCommitmentLcy: allocation.fundsCalled?.fromCommitmentLcy ?? 0,
          fromRecallableDistributionLcy:
            allocation.fundsCalled?.fromRecallableDistributionLcy ?? 0,
        },
      })),
    );
  };

  return (
    <>
      <Divider />
      <AdvanceSubscriptionAllocations
        vehicleId={vehicleId}
        currency={baseCurrency}
        capitalBreakdown={capitalBreakdown ?? []}
        onChange={handleAllocationsChange}
      />
    </>
  );
};

export default AdvanceSubscriptionPaymentDetails;
